import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-historico-pagamento',
  templateUrl: './consulta-historico-pagamento.component.html',
  styleUrls: ['./consulta-historico-pagamento.component.scss']
})
export class ConsultaHistoricoPagamentoComponent implements OnInit {
  title = "HISTÓRICO DE PAGAMENTO";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
